module.exports = __webpack_public_path__ + "media/coal_video.7f039acd.mp4";